import { render } from "./materialView.vue?vue&type=template&id=3ac2e94c"
import script from "./materialView.vue?vue&type=script&lang=js"
export * from "./materialView.vue?vue&type=script&lang=js"

import "./materialView.vue?vue&type=style&index=0&id=3ac2e94c&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__